import styled from 'styled-components';

// Main wrapper - handles scroll for the entire detail page
export const DetailPageMainWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 50px); /* Full height minus navbar */
  overflow-x: hidden;
  overflow-y: auto; /* This container handles the scroll */
  box-sizing: border-box;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.primaryWhite};
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.clearGray};
    border-radius: 3px;
  }
`;

// Inner container - handles margins and layout, no scroll
export const DetailPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  margin-inline: clamp(2rem, 8vw, 6.25rem); /* 32px a 100px responsivo */
  max-width: 100vw;
  padding-bottom: 2rem; /* Space at bottom for better UX */
  box-sizing: border-box;
  overflow: hidden;

  /* Estrategias preventivas para pantallas pequeñas */
  @media (max-width: 1200px) {
    margin-inline: clamp(1.5rem, 5vw, 4rem); /* 24px a 64px */
  }

  @media (max-width: 768px) {
    margin-inline: clamp(1rem, 4vw, 2rem); /* 16px a 32px */
  }

  @media (max-width: 480px) {
    margin-inline: 1rem; /* 16px fijo en móviles */
  }

  /* Prevenir overflow horizontal */
  & * {
    box-sizing: border-box;
  }

  /* Asegurar que el contenido no se rompa */
  & > * {
    min-width: 0; /* Permite que los elementos se encojan */
  }
`;

export const BackToTopButton = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 999;
  opacity: ${props => props.$visible ? 1 : 0};
  visibility: ${props => props.$visible ? 'visible' : 'hidden'};
  transform: translateY(${props => props.$visible ? 0 : '20px'});
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: ${props => props.$visible ? 'auto' : 'none'};
  
  /* Elevate above UploadFeedback when both are visible */
  @media (max-width: 768px) {
    bottom: 16px;
    right: 16px;
  }
`;

